import { ref } from '@vue/composition-api'
import { fetchTopLeagues } from '@ms/api/match'
import useCreateMatches from '@ms/components/match/useCreateMatches.js'

export default function useTopLeagues() {
  const { leagues: topLeagues, resetLeagues, setLeagues } = useCreateMatches('league')

  // top leagues count
  const topLeaguesCount = ref(0)

  const resetTopLeagues = () => {
    resetLeagues()
    topLeaguesCount.value = 0
  }

  // 获取 Top-League 比赛
  async function getTopLeagues(sportId = '') {
    const { error, data } = await fetchTopLeagues(sportId)
    if (error) {
      return Promise.reject(error)
    } else {
      setLeagues(data.tournaments)
      topLeaguesCount.value = data.matchesCount || 0
    }
  }

  return {
    topLeagues,
    topLeaguesCount,
    resetTopLeagues,
    getTopLeagues
  }
}
